(ns manatee.admin.users.handlers
  "Event handler support for the admin. users tab."
  (:require
   [ajax.core :as ajax]
   [ajax.edn :as ajax-edn]
   [kee-frame.core :as kf]
   [manatee.admin.app-db :as admin-db]
   [manatee.admin.handlers :as admin-handlers]
   [manatee.admin.users.app-db :as db]
   [manatee.components.notifications.handlers :as notifications]
   [manatee.session.handlers :as session]
   [manatee.user.app-db :as user-db]
   [manatee.user.handlers :as user-handlers]
   [re-frame.core :as rf]))

(rf/reg-event-db
 ::set-list-view
 (fn set-list-view
   [db [_ flag]]
   (db/set-list-view db flag)))

(rf/reg-event-fx
 ::select-view
 (fn select-view
   [{:keys [db]} [_ user-id list-view?]]
   {:db (admin-db/set-selected-user db user-id)
    :dispatch [::set-list-view list-view?]}))

(rf/reg-event-fx
 ::set-user-active?
 (fn set-user-active?
   [{:keys [db]} [_ user-id user-active?]]
   (let [user (admin-db/get-user db user-id)]
     {:db db
      :dispatch [::update-user
                 (assoc user :is-active user-active?)
                 user-id]})))

(rf/reg-event-db
 ::clear-selected-user
 (fn clear-selected-user
   [db _]
   (admin-db/set-selected-user db nil)))

(kf/reg-event-fx
 ::add-user
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn add-user
   [{:keys [db]} [user]]
   {:db (admin-db/set-adding-user? db true)
    :http-xhrio {:method :post
                 :uri (kf/path-for [:api/users])
                 :params (user-handlers/user->api user)
                 :format (ajax/json-request-format)
                 :response-format (ajax-edn/edn-response-format)
                 :on-success [::add-user-success]
                 :on-failure [::add-user-failure]}}))

(rf/reg-event-fx
 ::add-user-success
 (fn add-user-success
   [{:keys [db]} [_ {:keys [user] :as _response}]]
   {:db (admin-db/set-adding-user? db false)
    :dispatch-n [[::admin-handlers/load-users]
                 [::select-view nil true]
                 [::notifications/add-alert :main
                  {:message "User added successfully"
                   :type :info}
                  :auto-dismiss? true]
                 [::session/log-events {:events [{:event-type :admin-user
                                                  :data (assoc user :action "create")}]}]]}))

(rf/reg-event-fx
 ::add-user-failure
 (fn add-user-failure
   [{:keys [db]} [_ {:keys [response] :as _resp}]]
   {:db (admin-db/set-adding-user? db false)
    :dispatch [::notifications/add-alert :main
               {:message (or (get-in response [:reason :message])
                             "Unable to add user. Refresh the browser to try again or contact support if necessary.")
                :type :error}
               :auto-dismiss? true]}))

(kf/reg-event-fx
 ::update-user
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn update-user
   [{:keys [db]} [user user-id]]
   (let [user (-> (user-handlers/user->api user)
                  (assoc :id (str user-id)))]
     {:db (admin-db/set-user-updating? db user-id true)
      :http-xhrio {:method :put
                   :uri (kf/path-for [:api/users])
                   :params user
                   :format (ajax/json-request-format)
                   :response-format (ajax-edn/edn-response-format)
                   :on-success [::update-user-success user]
                   :on-failure [::update-user-failure]}})))

(rf/reg-event-fx
 ::update-user-success
 (fn update-user-success
   [{:keys [db]} [_ user _response]]
   (let [is-current-user? (= (:id user)
                             (user-db/get-user-id db))]
     {:db db
      :dispatch-n [[::admin-handlers/load-users]
                   [::clear-selected-user]
                   [::select-view nil true]
                   [::notifications/add-alert :main
                    {:message "User updated successfully"
                     :type :info}
                    :auto-dismiss? true]
                   [::session/log-events {:events [{:event-type :admin-user
                                                    :data (assoc user :action "update")}]}]
                   (when is-current-user?
                     [::user-handlers/reload-user])]})))

(rf/reg-event-fx
 ::update-user-failure
 (fn update-user-failure
   [{:keys [db]} [_ {:keys [response]}]]
   {:db db
    :dispatch [::notifications/add-alert :main
               {:message (or (get-in response [:reason :message])
                             "Unable to update user. Refresh the browser to try again or contact support if necessary.")
                :type :error}
               :auto-dismiss? true]}))
